import React from "react";
import { Chip, Stack } from "@mui/material";

import { JOB_STATUSES } from "../../constants";

const flow = {
  [JOB_STATUSES.NOT_STARTED]: { color: "grey" },
  [JOB_STATUSES.IN_PROGRESS]: { color: "blue" },
  [JOB_STATUSES.COMPLETE]: { color: "green" },
};
const sx = {
  "& .MuiChip-label": {
    fontSize: 10,
    fontWeight: 500,
  },
  my: "-4px",
};

const LineItemStatusChip = ({ item }) => {
  const label = item?.status || JOB_STATUSES.NOT_STARTED;
  const final = flow[label];

  return (
    <Stack direction="row" gap="5px">
      <Chip
        label={item?.status}
        variant="colorTag"
        flow={final.color}
        sx={sx}
      />
      {item?.canShip && (
        <Chip label="Ready To Ship" variant="colorTag" flow="main" sx={sx} />
      )}
    </Stack>
  );
};

export default LineItemStatusChip;
